/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateInterviewInviteDto,
  InterviewInviteAttemptDto,
  InterviewInviteDetailDto,
  InterviewInviteResponseDto,
  InterviewInviteSessionDto,
  InterviewInviteSessionIdsDto,
  ListInterviewInvitesParams,
  ListInterviewInvitesResponseDto,
  ReprocessInterviewInviteDto,
  ReprocessInterviewInviteResponseDto,
  ResendInterviewInviteWebhookResponseDto,
  ResolveInterviewInviteSessionIdsParams,
  TranscriptTurnDto
} from '../model';

import { customFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListInterviewInvitesUrl = (params: ListInterviewInvitesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["status"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/interview-invites?${stringifiedParams}` : `/interview-invites`
}

export const listInterviewInvites = async (params: ListInterviewInvitesParams, options?: Parameters<typeof customFetch>[1]): Promise<ListInterviewInvitesResponseDto> => {

  return customFetch<ListInterviewInvitesResponseDto>(getListInterviewInvitesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInterviewInvitesQueryKey = (params?: ListInterviewInvitesParams,) => {
    return [
    `/interview-invites`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInterviewInvitesQueryOptions = <TData = Awaited<ReturnType<typeof listInterviewInvites>>, TError = unknown>(params: ListInterviewInvitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterviewInvites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInterviewInvitesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInterviewInvites>>> = ({ signal }) => listInterviewInvites(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInterviewInvites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInterviewInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof listInterviewInvites>>>
export type ListInterviewInvitesQueryError = unknown


export function useListInterviewInvites<TData = Awaited<ReturnType<typeof listInterviewInvites>>, TError = unknown>(
 params: ListInterviewInvitesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterviewInvites>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInterviewInvites>>,
          TError,
          Awaited<ReturnType<typeof listInterviewInvites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInterviewInvites<TData = Awaited<ReturnType<typeof listInterviewInvites>>, TError = unknown>(
 params: ListInterviewInvitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterviewInvites>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInterviewInvites>>,
          TError,
          Awaited<ReturnType<typeof listInterviewInvites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInterviewInvites<TData = Awaited<ReturnType<typeof listInterviewInvites>>, TError = unknown>(
 params: ListInterviewInvitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterviewInvites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListInterviewInvites<TData = Awaited<ReturnType<typeof listInterviewInvites>>, TError = unknown>(
 params: ListInterviewInvitesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterviewInvites>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInterviewInvitesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateInterviewInviteUrl = () => {




  return `/interview-invites`
}

export const createInterviewInvite = async (createInterviewInviteDto: CreateInterviewInviteDto, options?: Parameters<typeof customFetch>[1]): Promise<InterviewInviteResponseDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<InterviewInviteResponseDto>(getCreateInterviewInviteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInterviewInviteDto)
  }
);}





export const getCreateInterviewInviteMutationKey = () => ['createInterviewInvite'] as const;

export const getCreateInterviewInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInterviewInvite>>, TError,CreateInterviewInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInterviewInvite>>, TError,CreateInterviewInviteMutationVariables, TContext> => {

const mutationKey = getCreateInterviewInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInterviewInvite>>, CreateInterviewInviteMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createInterviewInvite(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInterviewInviteMutationResult = NonNullable<Awaited<ReturnType<typeof createInterviewInvite>>>
    export type CreateInterviewInviteMutationBody = CreateInterviewInviteDto
    export type CreateInterviewInviteMutationError = unknown
    export type CreateInterviewInviteMutationVariables = {data: CreateInterviewInviteDto}

    export const useCreateInterviewInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInterviewInvite>>, TError,CreateInterviewInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInterviewInvite>>,
        TError,
        CreateInterviewInviteMutationVariables,
        TContext
      > => {
      return useMutation(getCreateInterviewInviteMutationOptions(options), queryClient);
    }
    export const getResolveInterviewInviteSessionIdsUrl = (params: ResolveInterviewInviteSessionIdsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["status"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/interview-invites/session-ids?${stringifiedParams}` : `/interview-invites/session-ids`
}

export const resolveInterviewInviteSessionIds = async (params: ResolveInterviewInviteSessionIdsParams, options?: Parameters<typeof customFetch>[1]): Promise<InterviewInviteSessionIdsDto> => {

  return customFetch<InterviewInviteSessionIdsDto>(getResolveInterviewInviteSessionIdsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getResolveInterviewInviteSessionIdsQueryKey = (params?: ResolveInterviewInviteSessionIdsParams,) => {
    return [
    `/interview-invites/session-ids`, ...(params ? [params] : [])
    ] as const;
    }


export const getResolveInterviewInviteSessionIdsQueryOptions = <TData = Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>, TError = unknown>(params: ResolveInterviewInviteSessionIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getResolveInterviewInviteSessionIdsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>> = ({ signal }) => resolveInterviewInviteSessionIds(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ResolveInterviewInviteSessionIdsQueryResult = NonNullable<Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>>
export type ResolveInterviewInviteSessionIdsQueryError = unknown


export function useResolveInterviewInviteSessionIds<TData = Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>, TError = unknown>(
 params: ResolveInterviewInviteSessionIdsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>,
          TError,
          Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolveInterviewInviteSessionIds<TData = Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>, TError = unknown>(
 params: ResolveInterviewInviteSessionIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>,
          TError,
          Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolveInterviewInviteSessionIds<TData = Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>, TError = unknown>(
 params: ResolveInterviewInviteSessionIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useResolveInterviewInviteSessionIds<TData = Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>, TError = unknown>(
 params: ResolveInterviewInviteSessionIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveInterviewInviteSessionIds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getResolveInterviewInviteSessionIdsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInterviewInviteUrl = (id: string,) => {




  return `/interview-invites/${id}`
}

export const getInterviewInvite = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<InterviewInviteDetailDto> => {

  return customFetch<InterviewInviteDetailDto>(getGetInterviewInviteUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInterviewInviteQueryKey = (id: string,) => {
    return [
    `/interview-invites/${id}`
    ] as const;
    }


export const getGetInterviewInviteQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewInvite>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInvite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewInviteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewInvite>>> = ({ signal }) => getInterviewInvite(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewInvite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInterviewInviteQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewInvite>>>
export type GetInterviewInviteQueryError = unknown


export function useGetInterviewInvite<TData = Awaited<ReturnType<typeof getInterviewInvite>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInvite>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInterviewInvite>>,
          TError,
          Awaited<ReturnType<typeof getInterviewInvite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInterviewInvite<TData = Awaited<ReturnType<typeof getInterviewInvite>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInvite>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInterviewInvite>>,
          TError,
          Awaited<ReturnType<typeof getInterviewInvite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInterviewInvite<TData = Awaited<ReturnType<typeof getInterviewInvite>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInvite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInterviewInvite<TData = Awaited<ReturnType<typeof getInterviewInvite>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInvite>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInterviewInviteQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDeleteInterviewInviteUrl = (id: string,) => {




  return `/interview-invites/${id}`
}

export const deleteInterviewInvite = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteInterviewInviteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteInterviewInviteMutationKey = () => ['deleteInterviewInvite'] as const;

export const getDeleteInterviewInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInterviewInvite>>, TError,DeleteInterviewInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInterviewInvite>>, TError,DeleteInterviewInviteMutationVariables, TContext> => {

const mutationKey = getDeleteInterviewInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInterviewInvite>>, DeleteInterviewInviteMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteInterviewInvite(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInterviewInviteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInterviewInvite>>>

    export type DeleteInterviewInviteMutationError = unknown
    export type DeleteInterviewInviteMutationVariables = {id: string}

    export const useDeleteInterviewInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInterviewInvite>>, TError,DeleteInterviewInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInterviewInvite>>,
        TError,
        DeleteInterviewInviteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteInterviewInviteMutationOptions(options), queryClient);
    }
    export const getListInterviewInviteSessionsUrl = (id: string,) => {




  return `/interview-invites/${id}/sessions`
}

export const listInterviewInviteSessions = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<InterviewInviteAttemptDto[]> => {

  return customFetch<InterviewInviteAttemptDto[]>(getListInterviewInviteSessionsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInterviewInviteSessionsQueryKey = (id: string,) => {
    return [
    `/interview-invites/${id}/sessions`
    ] as const;
    }


export const getListInterviewInviteSessionsQueryOptions = <TData = Awaited<ReturnType<typeof listInterviewInviteSessions>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterviewInviteSessions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInterviewInviteSessionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInterviewInviteSessions>>> = ({ signal }) => listInterviewInviteSessions(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInterviewInviteSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInterviewInviteSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listInterviewInviteSessions>>>
export type ListInterviewInviteSessionsQueryError = unknown


export function useListInterviewInviteSessions<TData = Awaited<ReturnType<typeof listInterviewInviteSessions>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterviewInviteSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInterviewInviteSessions>>,
          TError,
          Awaited<ReturnType<typeof listInterviewInviteSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInterviewInviteSessions<TData = Awaited<ReturnType<typeof listInterviewInviteSessions>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterviewInviteSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInterviewInviteSessions>>,
          TError,
          Awaited<ReturnType<typeof listInterviewInviteSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInterviewInviteSessions<TData = Awaited<ReturnType<typeof listInterviewInviteSessions>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterviewInviteSessions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListInterviewInviteSessions<TData = Awaited<ReturnType<typeof listInterviewInviteSessions>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInterviewInviteSessions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInterviewInviteSessionsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInterviewInviteSessionTurnsBySessionUrl = (id: string,
    sessionId: string,) => {




  return `/interview-invites/${id}/sessions/${sessionId}/turns`
}

export const getInterviewInviteSessionTurnsBySession = async (id: string,
    sessionId: string, options?: Parameters<typeof customFetch>[1]): Promise<TranscriptTurnDto[]> => {

  return customFetch<TranscriptTurnDto[]>(getGetInterviewInviteSessionTurnsBySessionUrl(id,sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInterviewInviteSessionTurnsBySessionQueryKey = (id: string,
    sessionId: string,) => {
    return [
    `/interview-invites/${id}/sessions/${sessionId}/turns`
    ] as const;
    }


export const getGetInterviewInviteSessionTurnsBySessionQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>, TError = unknown>(id: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewInviteSessionTurnsBySessionQueryKey(id,sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>> = ({ signal }) => getInterviewInviteSessionTurnsBySession(id,sessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInterviewInviteSessionTurnsBySessionQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>>
export type GetInterviewInviteSessionTurnsBySessionQueryError = unknown


export function useGetInterviewInviteSessionTurnsBySession<TData = Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>, TError = unknown>(
 id: string,
    sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>,
          TError,
          Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInterviewInviteSessionTurnsBySession<TData = Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>, TError = unknown>(
 id: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>,
          TError,
          Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInterviewInviteSessionTurnsBySession<TData = Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>, TError = unknown>(
 id: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInterviewInviteSessionTurnsBySession<TData = Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>, TError = unknown>(
 id: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSessionTurnsBySession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInterviewInviteSessionTurnsBySessionQueryOptions(id,sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getResendInterviewInviteWebhookUrl = (id: string,) => {




  return `/interview-invites/${id}/resend-webhook`
}

export const resendInterviewInviteWebhook = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ResendInterviewInviteWebhookResponseDto> => {

  return customFetch<ResendInterviewInviteWebhookResponseDto>(getResendInterviewInviteWebhookUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getResendInterviewInviteWebhookMutationKey = () => ['resendInterviewInviteWebhook'] as const;

export const getResendInterviewInviteWebhookMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInterviewInviteWebhook>>, TError,ResendInterviewInviteWebhookMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resendInterviewInviteWebhook>>, TError,ResendInterviewInviteWebhookMutationVariables, TContext> => {

const mutationKey = getResendInterviewInviteWebhookMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendInterviewInviteWebhook>>, ResendInterviewInviteWebhookMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  resendInterviewInviteWebhook(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendInterviewInviteWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof resendInterviewInviteWebhook>>>

    export type ResendInterviewInviteWebhookMutationError = unknown
    export type ResendInterviewInviteWebhookMutationVariables = {id: string}

    export const useResendInterviewInviteWebhook = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInterviewInviteWebhook>>, TError,ResendInterviewInviteWebhookMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendInterviewInviteWebhook>>,
        TError,
        ResendInterviewInviteWebhookMutationVariables,
        TContext
      > => {
      return useMutation(getResendInterviewInviteWebhookMutationOptions(options), queryClient);
    }
    export const getReprocessInterviewInviteUrl = (id: string,) => {




  return `/interview-invites/${id}/reprocess`
}

export const reprocessInterviewInvite = async (id: string,
    reprocessInterviewInviteDto: ReprocessInterviewInviteDto, options?: Parameters<typeof customFetch>[1]): Promise<ReprocessInterviewInviteResponseDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ReprocessInterviewInviteResponseDto>(getReprocessInterviewInviteUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reprocessInterviewInviteDto)
  }
);}





export const getReprocessInterviewInviteMutationKey = () => ['reprocessInterviewInvite'] as const;

export const getReprocessInterviewInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reprocessInterviewInvite>>, TError,ReprocessInterviewInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reprocessInterviewInvite>>, TError,ReprocessInterviewInviteMutationVariables, TContext> => {

const mutationKey = getReprocessInterviewInviteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reprocessInterviewInvite>>, ReprocessInterviewInviteMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  reprocessInterviewInvite(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReprocessInterviewInviteMutationResult = NonNullable<Awaited<ReturnType<typeof reprocessInterviewInvite>>>
    export type ReprocessInterviewInviteMutationBody = ReprocessInterviewInviteDto
    export type ReprocessInterviewInviteMutationError = unknown
    export type ReprocessInterviewInviteMutationVariables = {id: string;data: ReprocessInterviewInviteDto}

    export const useReprocessInterviewInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reprocessInterviewInvite>>, TError,ReprocessInterviewInviteMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reprocessInterviewInvite>>,
        TError,
        ReprocessInterviewInviteMutationVariables,
        TContext
      > => {
      return useMutation(getReprocessInterviewInviteMutationOptions(options), queryClient);
    }
    export const getGetInterviewInviteSessionUrl = (id: string,) => {




  return `/interview-invites/${id}/session`
}

export const getInterviewInviteSession = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<InterviewInviteSessionDto> => {

  return customFetch<InterviewInviteSessionDto>(getGetInterviewInviteSessionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInterviewInviteSessionQueryKey = (id: string,) => {
    return [
    `/interview-invites/${id}/session`
    ] as const;
    }


export const getGetInterviewInviteSessionQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewInviteSession>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewInviteSessionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewInviteSession>>> = ({ signal }) => getInterviewInviteSession(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInterviewInviteSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewInviteSession>>>
export type GetInterviewInviteSessionQueryError = unknown


export function useGetInterviewInviteSession<TData = Awaited<ReturnType<typeof getInterviewInviteSession>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInterviewInviteSession>>,
          TError,
          Awaited<ReturnType<typeof getInterviewInviteSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInterviewInviteSession<TData = Awaited<ReturnType<typeof getInterviewInviteSession>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInterviewInviteSession>>,
          TError,
          Awaited<ReturnType<typeof getInterviewInviteSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInterviewInviteSession<TData = Awaited<ReturnType<typeof getInterviewInviteSession>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInterviewInviteSession<TData = Awaited<ReturnType<typeof getInterviewInviteSession>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSession>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInterviewInviteSessionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetInterviewInviteSessionTurnsUrl = (id: string,) => {




  return `/interview-invites/${id}/session/turns`
}

export const getInterviewInviteSessionTurns = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<TranscriptTurnDto[]> => {

  return customFetch<TranscriptTurnDto[]>(getGetInterviewInviteSessionTurnsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInterviewInviteSessionTurnsQueryKey = (id: string,) => {
    return [
    `/interview-invites/${id}/session/turns`
    ] as const;
    }


export const getGetInterviewInviteSessionTurnsQueryOptions = <TData = Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterviewInviteSessionTurnsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>> = ({ signal }) => getInterviewInviteSessionTurns(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInterviewInviteSessionTurnsQueryResult = NonNullable<Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>>
export type GetInterviewInviteSessionTurnsQueryError = unknown


export function useGetInterviewInviteSessionTurns<TData = Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>,
          TError,
          Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInterviewInviteSessionTurns<TData = Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>,
          TError,
          Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInterviewInviteSessionTurns<TData = Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInterviewInviteSessionTurns<TData = Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInterviewInviteSessionTurns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInterviewInviteSessionTurnsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






